export function getDateRangeFromRows(rows) {
  if (!rows || rows.length === 0) {
    return [new Date().toISOString().split('T')[0]];
  }
  const dates = rows.map(row => new Date(row.startDate));
  const minDate = new Date(Math.min(...dates));
  const maxDate = new Date(Math.max(...dates));
  const allDates = [];
  for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
    allDates.push(new Date(d).toISOString().split('T')[0]);
  }
  return allDates;
}
